export default {
  name: "layout",
  inject: ["reload"],
  data() {
    return {};
  },
  mounted() {}
};